import { useQuery } from 'react-query';
import { getMenu } from '../../../service';
import { SubMenu } from '../Nav/style';

type Props = {
  hoveredItemId: number;
  onHover: (id:number) => void;
};

function SubNav({ hoveredItemId, onHover }: Props) {

  const { isLoading, error, data: gnbData } = useQuery(`getMenu-gnb`, () => getMenu('gnb'), {
    staleTime: 1000 * 60 * 60,
    cacheTime: 1000 * 60 * 60,
  });

  return (
    <>
    {
      !isLoading && !error && gnbData && (
        <>
        {
          gnbData.items.map((item:any, index:number) => (
          <div key={index}>
            {
              item.child_items && (
                <SubMenu key={index} hovered={item.ID === hoveredItemId} onMouseEnter={() => onHover(item.ID)} onMouseLeave={() => onHover(0)} >
                  <ul>
                    {
                      item.child_items.map((child:any, index:number) => (
                        <li key={index}>
                          <a href={child.url} target={child.target}>{child.title}</a>
                        </li>
                      ))
                    }
                  </ul>
                </SubMenu>
              )
            }
          </div>
          ))
        }
        </>
      )
    }
    </>
  );
}

SubNav.defaultProps = {
};

export default SubNav;
